import { Routes } from "@angular/router";

/**
 * Top-level routes for the auth application.
 *
 * Mounts the `session` domain at the empty path so consumer URLs are
 * `/auth/verify/...` and `/auth/unauthorized` (not `/auth/session/...`).
 */
export const authRoutes: Routes = [
  {
    path: "",
    loadChildren: () => import("./domains/session/session.routes").then(r => r.sessionRoutes),
  },
];
